<div class="container-fluid py-4">
  <!-- <h4 class="h4">(Courier Charges)</h4> -->

  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/registry']"
        >
          Registry
        </a>
        <a
          class="btn btn-dark btn-sm btn-reg"
          [routerLink]="['/marketing/seo/qaRun']"
        >
          QA Run
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/internalLinks']"
        >
          Internal Links
        </a>

        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageDashboard']"
        >
          On-P Insights
        </a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing']"
        >
          Keywords
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageRecommendations']"
        >
          Off-P Recomm
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageProspects']"
        >
          Off-P Prospects
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageBacklinks']"
        >
          Off-P Backlinks
        </a>
      </div>
    </div>
  </div>

  <!-- Campo de búsqueda mejorado con autocompletado -->
  <!-- <br /><br /><br /> -->
  <div class="row mb-3 mt-1">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filter()"
          list="suggestionsCourier"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="suggestionsCourier">
          <option
            *ngFor="let suggestion of searchSuggestions"
            [value]="suggestion"
          ></option>
        </datalist>
      </div>
    </div>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <h2>Details</h2>
    </div>
  </div>
  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Url</th>
              <th>Type</th>
              <th>City</th>
              <th>Service</th>
              <th>Industry</th>
              <th>Run</th>
              <th>Started</th>
              <th>Result</th>
              <th class="city-cell">QA Status</th>
              <th>Score</th>
              <th>Summary</th>
              <th>Issues</th>
              <th>Warnings</th>
              <th>Approval</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of filteredData">
              <td
                class="url-cell"
                (click)="showModal('Full URL', item.urlPath)"
                title="Click to view full URL"
              >
                {{ item.urlPath }}
              </td>
              <td>{{ item.type }}</td>
              <td class="city-cell">{{ item.city }}</td>
              <td>{{ item.service }}</td>
              <td>{{ item.industry }}</td>

              <td>{{ item.runType }}</td>
              <td>{{ item.startedAt | date: "yyyy-MM-dd HH:mm" }}</td>

              <td>
                <span
                  class="badge span__badge"
                  [ngClass]="badgePassed(item.passed)"
                >
                  {{ item.passed ? "PASS" : "FAIL" }}
                </span>
              </td>

              <td>
                <span
                  class="badge span__badgeqa"
                  [ngClass]="badgeQaStatus(item.status)"
                >
                  {{ item.status }}
                </span>
              </td>

              <td>{{ item.score ?? "-" }}</td>
              <td>{{ item.summary || "-" }}</td>

              <td>{{ (item.issuesCount ?? item.issues?.length) || 0 }}</td>
              <td>{{ (item.warningsCount ?? item.warnings?.length) || 0 }}</td>

              <td>
                <span
                  class="badge span__badge"
                  [ngClass]="
                    badgeApproval(item.approvalState || item?.approval?.state)
                  "
                >
                  {{ item.approvalState || item?.approval?.state || "pending" }}
                </span>
              </td>

              <td>
                <button
                  (click)="qaApprove(item._id)"
                  class="btn btn-link text-dark btn-sm"
                  [disabled]="!item.canApprove"
                  title="Approve"
                >
                  <i class="fa-solid fa-check"></i>
                </button>

                <button
                  (click)="openReject(item._id)"
                  class="btn btn-link text-dark btn-sm"
                  [disabled]="!item.canReject"
                  title="Reject"
                >
                  <i class="fa-solid fa-circle-xmark"></i>
                </button>

                <button
                  (click)="openDetails(item)"
                  class="btn btn-link text-dark btn-sm"
                  title="View"
                >
                  <i class="fa-solid fa-eye"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- modal para details de QA -->
  <div
    class="modal fade show qa-modal-top"
    tabindex="-1"
    [ngStyle]="{ display: detailsOpen ? 'block' : 'none' }"
    *ngIf="detailsOpen"
  >
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">QA Details</h5>
          <button
            type="button"
            class="btn-close"
            (click)="closeDetails()"
          ></button>
        </div>

        <div class="modal-body qa-modal-body">
          <div *ngIf="detailsLoading">Cargando...</div>

          <ng-container *ngIf="!detailsLoading && selectedQa">
            <div class="mb-3">
              <div><b>URL:</b> {{ selectedQa.urlPath }}</div>
              <div>
                <b>Status:</b> {{ selectedQa.status }} | <b>Approval:</b>
                {{ selectedQa.approvalState }}
              </div>
              <div><b>Score:</b> {{ selectedQa.score ?? "-" }}</div>
              <div><b>Summary:</b> {{ selectedQa.summary || "-" }}</div>
            </div>

            <hr />

            <div *ngIf="selectedQa?.approval?.state === 'rejected'">
              <b>Motivo rechazo:</b> {{ selectedQa.approval?.rejectReason }}
            </div>

            <h6>Issues ({{ selectedQa.issues?.length || 0 }})</h6>
            <div
              class="table-responsive"
              *ngIf="selectedQa.issues?.length; else noIssues"
            >
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Severity</th>
                    <th>Key</th>
                    <th>Message</th>
                    <th>Fix</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let it of selectedQa.issues">
                    <td>
                      <span
                        class="badge"
                        [ngClass]="badgeSeverity(it.severity)"
                      >
                        {{ it.severity }}
                      </span>
                    </td>
                    <td>{{ it.key }}</td>
                    <td>{{ it.message }}</td>
                    <td>{{ it.fix || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #noIssues>
              <div class="text-muted">No issues</div>
            </ng-template>

            <hr />

            <h6>Warnings ({{ selectedQa.warnings?.length || 0 }})</h6>
            <div
              class="table-responsive"
              *ngIf="selectedQa.warnings?.length; else noWarnings"
            >
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Severity</th>
                    <th>Key</th>
                    <th>Message</th>
                    <th>Fix</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let it of selectedQa.warnings">
                    <td>
                      <span
                        class="badge"
                        [ngClass]="badgeSeverity(it.severity)"
                      >
                        {{ it.severity }}
                      </span>
                    </td>
                    <td>{{ it.key }}</td>
                    <td>{{ it.message }}</td>
                    <td>{{ it.fix || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #noWarnings>
              <div class="text-muted">No warnings</div>
            </ng-template>
          </ng-container>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary btn-sm" (click)="closeDetails()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-backdrop fade show" *ngIf="detailsOpen"></div>

  <!-- modal para establecer motivo de rechazo  -->

  <div
    class="modal fade show"
    tabindex="-1"
    [ngStyle]="{ display: rejectOpen ? 'block' : 'none' }"
    *ngIf="rejectOpen"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">QA Reject</h5>
          <button
            type="button"
            class="btn-close"
            (click)="closeReject()"
          ></button>
        </div>

        <div class="modal-body">
          <form [formGroup]="form" (ngSubmit)="qaReject()">
            <div class="mb-2">
              <input
                type="text"
                class="form-control"
                placeholder="Motivo de rechazo..."
                formControlName="rejectReason"
              />
            </div>
            <!--  <button class="btn btn-primary btn-sm" (click)="qaReject()">
              Accept
            </button> -->
            <div class="row text-center">
              <div class="col-md-12">
                <button
                  type="submit"
                  class="btn btn-dark pull-right btn-create"
                  [disabled]="form.invalid"
                >
                  Accept
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary btn-sm" (click)="closeReject()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-backdrop fade show" *ngIf="rejectOpen"></div>
</div>

<!-- Modal -->
<div class="modal-url-overlay" *ngIf="modalContent" (click)="closeModal()">
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div
      class="modal-url-body text-dark"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      {{ modalContent }}
    </div>
  </div>
</div>
